<template>
    <div class="main">
        <c-panel>
            <detalhe-tarefa :paramId="$route.params.id"></detalhe-tarefa>
        </c-panel>
    </div>
</template>
<script>

import detalheTarefa from "./detalhe"

export default {
    components:{ 'detalhe-tarefa': detalheTarefa }
}
</script>
